/**
 * Directive: formsRadioGroup
 */
angular.module('acme.common.directive.forms.radioGroup', [
  'acme.common.directive.forms.radio'
])
.directive('formsRadioGroup', [function() {

    return {
      restrict: 'A',
      require: 'formsRadio',
      replace: true,
      templateUrl: 'common/directives/forms/radioGroup/radioGroup.tpl.html',
      scope: {
        items: '='
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.formsRadioGroup = {};

      }]

    };

}]);